module.exports = __webpack_public_path__ + "img/logo-white.fa80dc6c.svg";